export const LOYALTY_PAGE_URL = '/loyalty';
